export const refs = {
  body: document.querySelector('body'),
  userAuth: document.querySelector('#auth'),

  modalAuth: document.querySelector('.backdrop-auth'),
  authContainer: document.querySelector('.auth-container'),

  closeModalBtn: document.querySelector('#close-modal-btn'),
  closeModalCross: document.querySelector('#close-modal-cross'),
  closeModalSvg: document.querySelector('.auth-modal__close-icon'),

  logInPage: document.querySelector('#log-in-page'),
  logInTab: document.querySelector('#log-in-tab'),
  logInForm: document.querySelector('#log-in-form'),
  logInBtn: document.querySelector('#log-in-btn'),
  regTab: document.querySelector('#reg-tab'),
  regForm: document.querySelector('#reg-form'),
  regBtn: document.querySelector('#register'),

  userSetPage: document.querySelector('#user-settings-page'),
  settingsTab: document.querySelector('#settings-tab'),
  updForm: document.querySelector('#upd-form'),
  chName: document.querySelector('#change-name'),
  chEmail: document.querySelector('#change-email'),
  chPswd: document.querySelector('#change-pswd'),
  logOutBtn: document.querySelector('#log-out-btn'),
  delAccTab: document.querySelector('#delete-accnt-tab'),
  confDelAcc: document.querySelector('#confDelAcc'),
  delAccBtn: document.querySelector('#delAccBtn'),
  delAccBtnYes: document.querySelector('#delAccBtnYes'),
  delAccBtnNo: document.querySelector('#delAccBtnNo'),

  showPswd: document.querySelectorAll('.show-pswd'),
  hidePswd: document.querySelectorAll('.hide-pswd'),
  logInPswd: document.querySelector('#logInPswd'),
  regPswd: document.querySelector('#reg-pswd'),

  userLibrary: document.querySelector('.btn2'),
  heroLibrary: document.querySelector('.hero__img-library'),
  watchedBtn: document.querySelector('.btn__watched'),
  queueBtn: document.querySelector('.btn__queue'),
  heroLibrary: document.querySelector('.card-list'),
  modalCardWached: document.querySelector('.film-card-addToWatched'),
  modalCardQueue: document.querySelector('.film-card-addToQueue'),
};
